import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import Loader from "../../components/shared/Loader";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const PagesShow = ({ match }) => {
	const {
		params: { pageID },
	} = match;

	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [url, setUrl] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [loading, setLoading] = useState(true);
	const [pageTitle, setPageTitle] = useState("");
	const [pageUrl, setPageUrl] = useState("");
	const [pageDescrition, setPageDescrition] = useState("");
	const [pageKeyWords, setPageKeyWords] = useState("");
	const dispatch = useDispatch();

	let editor = null;

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل الصفحة",
				breadcrumb: "الصفحات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/pages/${pageID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setTitle(response.data.data.title);
				setDescription(response.data.data.description);
				setUrl(response.data.data.url);
				setPicture(response.data.data.image);
				setPageTitle(response.data.data.page_title);
				setPageDescrition(response.data.data.page_description);
				setPageKeyWords(response.data.data.page_keywords);
				setPageUrl(response.data.data.page_url_title);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = e => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const handleSubmit = e => {
		e.preventDefault();
		setLoading(true);
		const titleArray = {
			ar: title,
			en: "ttt",
		};
		const descriptionArray = {
			ar: description,
			en: "ttt",
		};
		const picture = document.querySelector("#picture");
		if (picture.files[0]) {
			const data = new FormData();
			data.append("file", picture.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					axios
						.put(
							`${process.env.REACT_APP_API_URL}/pages/${pageID}`,
							{
								title: titleArray,
								description: descriptionArray,
								url: url,
								image: response.data.data.name,
								page_title: pageTitle,
								page_description: pageDescrition,
								page_keywords: pageKeyWords,
								page_url_title: pageUrl,
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(function (response) {
							toast.success("تم تحديث الصفحة بنجاح!");
							setLoading(false);
						})
						.catch(function (error) {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(error => {
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
			return;
		}
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/pages/${pageID}`,
				{
					title: titleArray,
					description: descriptionArray,
					url: url,
					page_title: pageTitle,
					page_description: pageDescrition,
					page_keywords: pageKeyWords,
					page_url_title: pageUrl,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم تحديث الصفحة بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										required
										onChange={e => setTitle(e.target.value)}
										value={title}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="url">الرابط</label>
									<input
										type="url"
										id="url"
										required
										onChange={e => setUrl(e.target.value)}
										value={url}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="description">النص</label>
									<CKEditor
										data={description}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											// eslint-disable-next-line no-self-assign
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setDescription(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">تفاصيل محركات البحث</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="pageTitle">عنوان الصفحة</label>
									<input
										type="text"
										id="pageTitle"
										required
										onChange={e => setPageTitle(e.target.value)}
										value={pageTitle}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageUrl">رابط الصفحة</label>
									<input
										type="text"
										id="pageUrl"
										required
										onChange={e => setPageUrl(e.target.value)}
										value={pageUrl}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageDescription">وصف الصفحة</label>
									<textarea
										id="pageDescription"
										rows="2"
										onChange={e => setPageDescrition(e.target.value)}
										required
										value={pageDescrition}
									></textarea>
								</div>
								<div className="form-item">
									<label htmlFor="pageKeyWords">الكلمات المفتاحية</label>
									<textarea
										id="pageKeyWords"
										rows="2"
										onChange={e => setPageKeyWords(e.target.value)}
										required
										value={pageKeyWords}
									></textarea>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default PagesShow;
